/**
 * TariffSection Component
 *
 * Utility tariff selection using UnifiedTariffSelector from shared-ui.
 */

import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
} from '@mui/material';
import { vortxColors, vortxTypography, UnifiedTariffSelector } from '@vortx/shared-ui';

function TariffSection({ project, onUpdate }) {
  const [selectedTariff, setSelectedTariff] = useState(null);

  useEffect(() => {
    if (project && project.electric_tariff_id) {
      setSelectedTariff({
        id: project.electric_tariff_id,
        utility_name: project.utility || '',
        name: project.electric_tariff_name || '',
      });
    }
  }, [project]);

  const handleTariffSelect = async (tariff) => {
    if (!tariff) return;

    setSelectedTariff(tariff);

    await onUpdate({
      utility: tariff.utility_name || tariff.utility || '',
      electric_tariff_id: tariff.id || '',
      electric_tariff_name: tariff.name || '',
      electric_tariff_data: tariff.rate_data || tariff,
    });
  };

  return (
    <Box>
      <Typography
        variant="h5"
        sx={{
          fontFamily: vortxTypography.heading,
          color: vortxColors.white,
          mb: 3,
        }}
      >
        Utility Tariffs
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: vortxColors.stone,
          mb: 3,
        }}
      >
        Select the electricity tariff for your data center. This determines energy and demand
        charges used in the optimization.
      </Typography>

      <Paper
        sx={{
          p: 3,
          bgcolor: vortxColors.charcoal,
          border: `1px solid ${vortxColors.teal}`,
        }}
      >
        <UnifiedTariffSelector
          selectedTariff={selectedTariff}
          onTariffSelect={handleTariffSelect}
          matchSource="vortx"
        />
      </Paper>
    </Box>
  );
}

export default TariffSection;
